import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ReportConcernPage } from './pages/ReportConcernPage';
import { FoodSafetyPage } from './pages/FoodSafetyPage';
import { EnvironmentalHealthPage } from './pages/EnvironmentalHealthPage';
export function App() {
  const [page, setPage] = useState(window.location.hash);
  useEffect(() => {
    const onHashChange = () => setPage(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  if (page === '#report') {
    return <ReportConcernPage data-id="element-0" />;
  }
  if (page === '#report-food') {
    return <FoodSafetyPage data-id="element-1" />;
  }
  if (page === '#report-environmental') {
    return <EnvironmentalHealthPage data-id="element-2" />;
  }
  return <HomePage data-id="element-3" />;
}